import dayjs from 'dayjs';
import { User } from 'types';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

enum DAYS {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

enum MERIDIEM {
  PM = 'PM',
  AM = 'AM',
}

export const convertTime12to24 = (
  time: string | undefined,
  meridiem: string | undefined
) => {
  if (!time || !meridiem) {
    return;
  }

  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (meridiem === MERIDIEM.PM) {
    let parse = parseInt(hours, 10) + 12;
    hours = parse.toString();
  }

  return `${hours}:${minutes}`;
};

export const setHoursAndMinutes = (time: string | undefined) => {
  if (!time) {
    return;
  }

  const [hours, minutes] = time.split(':');

  return dayjs()
    .hour(Number(hours))
    .minute(Number(minutes));
};

const getDayOfWeek = (day: number) => {
  switch (day) {
    case 0:
      return DAYS.SUNDAY;
    case 1:
      return DAYS.MONDAY;
    case 2:
      return DAYS.TUESDAY;
    case 3:
      return DAYS.WEDNESDAY;
    case 4:
      return DAYS.THURSDAY;
    case 5:
      return DAYS.FRIDAY;
    case 6:
      return DAYS.SATURDAY;
    default:
      return null;
  }
};

export const checkIfAdvisorIsOnline = (advisorDetails: User) => {
  const weekday = getDayOfWeek(dayjs().day());

  if (!weekday) {
    return false;
  }

  const workingHour = advisorDetails.workingHours[weekday];

  const from24Hour = convertTime12to24(
    workingHour?.from.hours,
    workingHour?.from.meridiem
  );
  const to24Hour = convertTime12to24(
    workingHour?.to.hours,
    workingHour?.to.meridiem
  );

  const to = setHoursAndMinutes(to24Hour);
  const from = setHoursAndMinutes(from24Hour);
  return dayjs().isBetween(from, to, 'minutes');
};

// dobule check to combine toMMSS and formatTimeToString using dayjs
export const toMMSS = (sec_num: number, fractionDigits = 1) => {
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor((sec_num - hours * 3600) / 60);
  const seconds = sec_num - hours * 3600 - minutes * 60;

  if (isNaN(minutes)) {
    return '00:00.0';
  }

  let time = '';
  if (minutes < 10) {
    time += '0';
  }
  time += minutes + ':';
  if (seconds < 10) {
    time += '0';
  }
  time += seconds.toFixed(fractionDigits);
  return time;
};

// Function to format time duration to string of mm:ss.
export const formatTimeToString = (time: number) => {
  let timeMinutes = Math.floor(time / 60);
  let timeMinutesString = timeMinutes.toString();
  let timeSeconds = `${Math.floor(time - timeMinutes * 60)}`;
  if (timeMinutesString.length === 1) timeMinutesString = `0${timeMinutes}`;
  if (timeSeconds.length === 1) timeSeconds = `0${timeSeconds}`;
  return `${timeMinutes}:${timeSeconds}`;
};

export const formatDurationToSeconds = (time: number) => {
  let timeMinutes = Math.floor(time / 60);
  let timeMinutesString = timeMinutes.toString();
  let timeSeconds = `${Math.floor(time - timeMinutes * 60)}`;
  if (timeMinutesString.length === 1) timeMinutesString = `0${timeMinutes}`;
  if (timeSeconds.length === 1) timeSeconds = `0${timeSeconds}`;
  const hms = `${timeMinutes}:${timeSeconds}`;
  const a = hms.split(':');
  const seconds = +a[0] * 60 + +a[1];
  return seconds;
};
